import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: 0,
};

export default function taskTemplatesAddReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_TASK_TEMPLATES_ADD_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_TASK_TEMPLATES_ADD_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_TASK_TEMPLATES_ADD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
